(
    function (skyward, $, undefined)
    {
        skyward.keys = skyward.keys || {};

        var keysByCode =
        {
            0:
            {
                name: "That key has no keycode",
                value: undefined
            },
            3:
            {
                name: "break",
                value: undefined
            },
            8:
            {
                name: "backspace / delete",
                value: "\b"
            },
            9:
            {
                name: "tab",
                value: "\t"
            },
            12:
            {
                name: 'clear',
                value: undefined
            },
            13:
            {
                name: "enter",
                value: "\r\n"
            },
            16:
            {
                name: "shift",
                value: undefined
            },
            17:
            {
                name: "ctrl",
                value: undefined
            },
            18:
            {
                name: "alt",
                value: undefined
            },
            19:
            {
                name: "pause/break",
                value: undefined
            },
            20:
            {
                name: "caps lock",
                value: undefined
            },
            21:
            {
                name: "hangul",
                value: undefined
            },
            25:
            {
                name: "hanja",
                value: undefined
            },
            27:
            {
                name: "escape",
                value: undefined
            },
            28:
            {
                name: "conversion",
                value: undefined
            },
            29:
            {
                name: "non-conversion",
                value: undefined
            },
            32:
            {
                name: "spacebar",
                value: " "
            },
            33:
            {
                name: "page up",
                value: undefined
            },
            34:
            {
                name: "page down",
                value: undefined
            },
            35:
            {
                name: "end",
                value: undefined
            },
            36:
            {
                name: "home",
                value: undefined
            },
            37:
            {
                name: "left arrow",
                value: undefined
            },
            38:
            {
                name: "up arrow",
                value: undefined
            },
            39:
            {
                name: "right arrow",
                value: undefined
            },
            40:
            {
                name: "down arrow",
                value: undefined
            },
            41:
            {
                name: "select",
                value: undefined
            },
            42:
            {
                name: "print",
                value: undefined
            },
            43:
            {
                name: "execute",
                value: undefined
            },
            44:
            {
                name: "Print Screen",
                value: undefined
            },
            45:
            {
                name: "insert",
                value: undefined
            },
            46:
            {
                name: "delete",
                value: undefined
            },
            47:
            {
                name: "help",
                value: undefined
            },
            48:
            {
                name: "0",
                value: "0"
            },
            49:
            {
                name: "1",
                value: "1"
            },
            50:
            {
                name: "2",
                value: "2"
            },
            51:
            {
                name: "3",
                value: "3"
            },
            52:
            {
                name: "4",
                value: "4"
            },
            53:
            {
                name: "5",
                value: "5"
            },
            54:
            {
                name: "6",
                value: "6"
            },
            55:
            {
                name: "7",
                value: "7"
            },
            56:
            {
                name: "8",
                value: "8"
            },
            57:
            {
                name: "9",
                value: "9"
            },
            58:
            {
                name: ":",
                value: ":"
            },
            59:
            {
                name: "semicolon (firefox), equals",
                value: ";"
            },
            60:
            {
                name: "<",
                value: "<"
            },
            61:
            {
                name: "equals (firefox)",
                value: "="
            },
            63:
            {
                name: "ß",
                value: "ß"
            },
            64:
            {
                name: "@ (firefox)",
                value: "@"
            },
            65:
            {
                name: "a",
                value: "a"
            },
            66:
            {
                name: "b",
                value: "b"
            },
            67:
            {
                name: "c",
                value: "c"
            },
            68:
            {
                name: "d",
                value: "d"
            },
            69:
            {
                name: "e",
                value: "e"
            },
            70:
            {
                name: "f",
                value: "f"
            },
            71:
            {
                name: "g",
                value: "g"
            },
            72:
            {
                name: "h",
                value: "h"
            },
            73:
            {
                name: "i",
                value: "i"
            },
            74:
            {
                name: "j",
                value: "j"
            },
            75:
            {
                name: "k",
                value: "k"
            },
            76:
            {
                name: "l",
                value: "l"
            },
            77:
            {
                name: "m",
                value: "m"
            },
            78:
            {
                name: "n",
                value: "n"
            },
            79:
            {
                name: "o",
                value: "o"
            },
            80:
            {
                name: "p",
                value: "p"
            },
            81:
            {
                name: "q",
                value: "q"
            },
            82:
            {
                name: "r",
                value: "r"
            },
            83:
            {
                name: "s",
                value: "s"
            },
            84:
            {
                name: "t",
                value: "t"
            },
            85:
            {
                name: "u",
                value: "u"
            },
            86:
            {
                name: "v",
                value: "v"
            },
            87:
            {
                name: "w",
                value: "w"
            },
            88:
            {
                name: "x",
                value: "x"
            },
            89:
            {
                name: "y",
                value: "y"
            },
            90:
            {
                name: "z",
                value: "z"
            },
            91:
            {
                name: "Windows Key / Left looped square / Chromebook Search key",
                value: undefined
            },
            92:
            {
                name: "right window key",
                value: undefined
            },
            93:
            {
                name: "Windows Menu / Right looped square",
                value: undefined
            },
            95:
            {
                name: "sleep",
                value: undefined
            },
            96:
            {
                name: "numpad 0",
                value: "0"
            },
            97:
            {
                name: "numpad 1",
                value: "1"
            },
            98:
            {
                name: "numpad 2",
                value: "2"
            },
            99:
            {
                name: "numpad 3",
                value: "3"
            },
            100:
            {
                name: "numpad 4",
                value: "4"
            },
            101:
            {
                name: "numpad 5",
                value: "5"
            },
            102:
            {
                name: "numpad 6",
                value: "6"
            },
            103:
            {
                name: "numpad 7",
                value: "7"
            },
            104:
            {
                name: "numpad 8",
                value: "8"
            },
            105:
            {
                name: "numpad 9",
                value: "9"
            },
            106:
            {
                name: "multiply",
                value: "*"
            },
            107:
            {
                name: "add",
                value: "+"
            },
            108:
            {
                name: "numpad period (firefox)",
                value: "."
            },
            109:
            {
                name: "subtract",
                value: "-"
            },
            110:
            {
                name: "decimal point",
                value: "."
            },
            111:
            {
                name: "divide",
                value: "/"
            },
            112:
            {
                name: "f1",
                value: undefined
            },
            113:
            {
                name: "f2",
                value: undefined
            },
            114:
            {
                name: "f3",
                value: undefined
            },
            115:
            {
                name: "f4",
                value: undefined
            },
            116:
            {
                name: "f5",
                value: undefined
            },
            117:
            {
                name: "f6",
                value: undefined
            },
            118:
            {
                name: "f7",
                value: undefined
            },
            119:
            {
                name: "f8",
                value: undefined
            },
            120:
            {
                name: "f9",
                value: undefined
            },
            121:
            {
                name: "f10",
                value: undefined
            },
            122:
            {
                name: "f11",
                value: undefined
            },
            123:
            {
                name: "f12",
                value: undefined
            },
            124:
            {
                name: "f13",
                value: undefined
            },
            125:
            {
                name: "f14",
                value: undefined
            },
            126:
            {
                name: "f15",
                value: undefined
            },
            127:
            {
                name: "f16",
                value: undefined
            },
            128:
            {
                name: "f17",
                value: undefined
            },
            129:
            {
                name: "f18",
                value: undefined
            },
            130:
            {
                name: "f19",
                value: undefined
            },
            131:
            {
                name: "f20",
                value: undefined
            },
            132:
            {
                name: "f21",
                value: undefined
            },
            133:
            {
                name: "f22",
                value: undefined
            },
            134:
            {
                name: "f23",
                value: undefined
            },
            135:
            {
                name: "f24",
                value: undefined
            },
            144:
            {
                name: "num lock",
                value: undefined
            },
            145:
            {
                name: "scroll lock",
                value: undefined
            },
            160:
            {
                name: "^",
                value: "^"
            },
            161:
            {
                name: "!",
                value: "!"
            },
            163:
            {
                name: "#",
                value: "#"
            },
            164:
            {
                name: "$",
                value: "$"
            },
            165:
            {
                name: "u with grave accent",
                value: undefined
            },
            166:
            {
                name: "page backward",
                value: undefined
            },
            167:
            {
                name: "page forward",
                value: undefined
            },
            168:
            {
                name: "refresh",
                value: undefined
            },
            169:
            {
                name: "closing paren (AZERTY)",
                value: ")"
            },
            170:
            {
                name: "*",
                value: "*"
            },
            171:
            {
                name: "~ + * key",
                value: "~"
            },
            172:
            {
                name: "home key",
                value: undefined
            },
            173:
            {
                name: "minus (firefox), mute/unmute",
                value: "-"
            },
            174:
            {
                name: "decrease volume level",
                value: undefined
            },
            175:
            {
                name: "increase volume level",
                value: undefined
            },
            176:
            {
                name: "next",
                value: undefined
            },
            177:
            {
                name: "previous",
                value: undefined
            },
            178:
            {
                name: "stop",
                value: undefined
            },
            179:
            {
                name: "play/pause",
                value: undefined
            },
            180:
            {
                name: "e-mail",
                value: undefined
            },
            181:
            {
                name: "mute/unmute (firefox)",
                value: undefined
            },
            182:
            {
                name: "decrease volume level (firefox)",
                value: undefined
            },
            183:
            {
                name: "increase volume level (firefox)",
                value: undefined
            },
            186:
            {
                name: "semi-colon / n with tilde",
                value: ";"
            },
            187:
            {
                name: "equal sign",
                value: "="
            },
            188:
            {
                name: "comma",
                value: ","
            },
            189:
            {
                name: "dash",
                value: "-"
            },
            190:
            {
                name: "period",
                value: "."
            },
            191:
            {
                name: "forward slash / cedilla",
                value: "/"
            },
            192:
            {
                name: "grave accent / n with tilde / ash / o with umlaut mark",
                value: "`"
            },
            193:
            {
                name: "?, / or degree sign",
                value: "?"
            },
            194:
            {
                name: "numpad period (chrome)",
                value: "."
            },
            219:
            {
                name: "open bracket",
                value: "["
            },
            220:
            {
                name: "back slash",
                value: "\\"
            },
            221:
            {
                name: "close bracket / a with ring above",
                value: "]"
            },
            222:
            {
                name: "single quote / slashed o / a with umlaut mark",
                value: "\'"
            },
            223:
            {
                name: "`",
                value: "`"
            },
            224:
            {
                name: "left or right looped square key (firefox)",
                value: undefined
            },
            225:
            {
                name: "altgr",
                value: undefined
            },
            226:
            {
                name: "< /git >, left back slash",
                value: "//"
            },
            230:
            {
                name: "GNOME Compose Key",
                value: undefined
            },
            231:
            {
                name: "cedilla",
                value: undefined
            },
            233:
            {
                name: "XF86Forward",
                value: undefined
            },
            234:
            {
                name: "XF86Back",
                value: undefined
            },
            240:
            {
                name: "alphanumeric",
                value: undefined
            },
            242:
            {
                name: "hiragana/katakana",
                value: undefined
            },
            243:
            {
                name: "half-width/full-width",
                value: undefined
            },
            244:
            {
                name: "kanji",
                value: undefined
            },
            255:
            {
                name: "toggle touchpad",
                value: undefined
            }
            };

        skyward.keys.globalShiftPressed = false;
        skyward.keys.globalCtrlPressed = false;
        skyward.keys.globalAltPressed = false;
        skyward.keys.globalMetaPressed = false;
        skyward.keys.lastKeyUp = null;

        var debounceMainMenuToggle = skyward.debounce(function ()
        {
            skyward.mainMenu.toggleMenu();
        }, 200);

        var globalDown = function (event)
        {
            if (event)
            {
                skyward.keys.globalShiftPressed = event.shiftKey;
                skyward.keys.globalCtrlPressed = event.ctrlKey;
                skyward.keys.globalAltPressed = event.altKey;
                skyward.keys.globalMetaPressed = event.metaKey;
                var mKey = 77; // m key code

                // pressing alt and m opens the navigation menu
                if (skyward.keys.globalAltPressed && event.which == mKey)
                {
                    debounceMainMenuToggle();
                }
                switch (event.which)
                {
                    case 13:
                        if (document.activeElement && document.activeElement.tagName == 'A')
                        {
                            document.activeElement.click();
                            return false;
                        }
                        break;
                }
            }
        };
        var globalUp = function (event)
        {
            if (event)
            {
                skyward.keys.globalShiftPressed = event.shiftKey;
                skyward.keys.globalCtrlPressed = event.ctrlKey;
                skyward.keys.globalAltPressed = event.altKey;
                skyward.keys.globalMetaPressed = event.metaKey;
                skyward.keys.lastKeyUp = event.which;
            }
        };

        skyward.keys.keyIsNumberOrLetter = function (shiftKey, keyCode)
        {
            if ((keyCode >= 96 && keyCode <= 105 || //numpad
                    keyCode >= 48 && keyCode <= 57 || //digits
                    keyCode >= 65 && keyCode <= 90) && //letters
                !(shiftKey && (keyCode >= 48 || keyCode <= 57))) //exclude symbols
            {
                return true;
            }

            return false;
        };

        /**
         * Accepts a keyCode value and returns true if that value is defined in keysByCode.
         * Backspace/Delete is also considered a printable character.
         * @param {any} keyCode - the value of the key being pressed to compare
         */
        skyward.keys.isPrintableCharacter = function (keyCode)
        {
            if (keysByCode.hasOwnProperty(keyCode) && keysByCode[keyCode].value)
            {
                return true;
            }
            return false;
        }

        /**
         * Accepts a keyboard event and returns an object of named keys.
         * If key name has a value of true, the key was pressed.
         * NOTE: *** DONT USE THIS FUNCTION TO HANDLE KEYPRESS EVENTS ***
         *       Keypress events use different character code and don't trigger for non-character keys.
         * @param {event} keyboardEvent - An event that is generated by a keyboard event, such as keyDown/keyUp
         * @return {object} An object key names.  If the key name has a value of true, the key was pressed.
         * @example
         *
         *     var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
         *     if (eventKeys.ENTER)
         *     {
         *         // Do something when the Enter key is pressed
         *     }
         */
        skyward.keys.getKeyNamesFromEvent = (function ()
        {
            var initialized = false;
            var namedKeys = {};
            var keyDataTemplete = {};

            return function (keyboardEvent)
            {
                if (!initialized)
                {
                    init();
                }

                // normalize the eventKeyCode when using keypress
                if (keyboardEvent.type === "keypress")
                {
                    console.warn("[Warning] getKeyNamesFromEvent doesn't support the keypress event.");
                    return;
                }

                var eventKeyCode = keyboardEvent.keyCode || keyboardEvent.which; // Fallback depending on support

                var keyData = getKeyDataTemplete();
                var keyName = namedKeys[eventKeyCode];

                if (typeof keyData[keyName] !== "undefined")
                {
                    keyData[keyName] = true;
                }

                if (keyboardEvent.shiftKey) { keyData["SHIFT"] = true; }
                if (keyboardEvent.ctrlKey) { keyData["CTRL"] = true; }
                if (keyboardEvent.altKey) { keyData["ALT"] = true; }

                return keyData;
            };

            function init()
            {
                namedKeys =
                {
                    8: "BACKSPACE",
                    9: "TAB",
                    13: "ENTER",
                    16: "SHIFT",
                    17: "CTRL",
                    18: "ALT",
                    20: "CAPS_LOCK",
                    27: "ESC",
                    32: "SPACE",
                    37: "ARROW_LEFT",
                    38: "ARROW_UP",
                    39: "ARROW_RIGHT",
                    40: "ARROW_DOWN",
                    46: "DELETE",
                    48: "ZERO",
                    49: "ONE",
                    50: "TWO",
                    51: "THREE",
                    52: "FOUR",
                    53: "FIVE",
                    54: "SIX",
                    55: "SEVEN",
                    56: "EIGHT",
                    57: "NINE",
                    65: "A",
                    66: "B",
                    67: "C",
                    68: "D",
                    69: "E",
                    70: "F",
                    71: "G",
                    72: "H",
                    73: "I",
                    74: "J",
                    75: "K",
                    76: "L",
                    77: "M",
                    78: "N",
                    79: "O",
                    80: "P",
                    81: "Q",
                    82: "R",
                    83: "S",
                    84: "T",
                    85: "U",
                    86: "V",
                    87: "W",
                    88: "X",
                    89: "Y",
                    90: "Z",
                    96: "ZERO",
                    97: "ONE",
                    98: "TWO",
                    99: "THREE",
                    100: "FOUR",
                    101: "FIVE",
                    102: "SIX",
                    103: "SEVEN",
                    104: "EIGHT",
                    105: "NINE",
                    112: "F1",
                    113: "F2",
                    114: "F3",
                    115: "F4"
                };

                for (var key in namedKeys)
                {
                    keyDataTemplete[namedKeys[key]] = false;
                }

                initialized = true;
            }

            function getKeyDataTemplete()
            {
                return Object.assign({}, keyDataTemplete);
            }
        })();

        skyward.keys.getKeyFromEvent = function (keyboardEvent)
        {
            var returnObj = { name: "unknown", value: undefined };

            var eventKey = keyboardEvent.key; // Not supported Safari 10.2 downward ( https://caniuse.com/#search=keyboardevent.key )
            if (eventKey)
            {
                returnObj =
                {
                    name: eventKey.toLowerCase(),
                    value: eventKey
                };
                return returnObj;
            }

            var eventKeyCode = keyboardEvent.keyCode || keyboardEvent.which; // Fallback depending on support

            // Use "keydown" and "keyup" if you care about what keyboard key was pressed
            if (keyboardEvent.type === "keydown" || keyboardEvent.type === "keyup")
            {
                // Return the key based on keybarod key code
                returnObj = keysByCode[eventKeyCode];
                return returnObj;
            }

            // Use "keypress" if you care about what character was actually typed
            if (keyboardEvent.type === "keypress")
            {
                var value = String.fromCharCode(eventKeyCode); // Return the key based on char code
                returnObj =
                {
                    name: value.toLowerCase(),
                    value: value
                };
                return returnObj;
            }

            return returnObj;
        };

        $(function ()
        {
            "use strict";
            var jqDocument = $(document);
            jqDocument.on('keydown', globalDown);
            jqDocument.on('keyup', globalUp);
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);